function parseURLSearchParamsFromPath(asPath: string) {
  const [, query] = asPath.split('?');

  if (!query) return new URLSearchParams();

  return new URLSearchParams(`?${query}`);
}

function urlSearchParamsToQuery(params: URLSearchParams) {
  return params.toString() ? `?${params.toString()}` : '';
}

export function updateURLSearchParams(updateFn: (params: URLSearchParams) => URLSearchParams) {
  return (path: string) => {
    const [pathWithoutQuery] = path.split('?');
    const params = parseURLSearchParamsFromPath(path);
    const updated = updateFn(params);
    const newQuery = urlSearchParamsToQuery(updated);
    return pathWithoutQuery + newQuery;
  }
}
